export const FETCH_REQUESTTYPE_ACTION = "FETCH_REQUESTTYPE_ACTION";
export const FETCH_REQUESTTYPE_FAIL_ACTION =
  FETCH_REQUESTTYPE_ACTION + "_ERROR";
export const FETCH_REQUESTTYPE_SUCCESS_ACTION =
  FETCH_REQUESTTYPE_ACTION + "_SUCCESS";

export const FETCH_PARTNER_ACTION = "FETCH_PARTNER_ACTION";
export const FETCH_PARTNER_FAIL_ACTION = FETCH_PARTNER_ACTION + "_ERROR";
export const FETCH_PARTNER_SUCCESS_ACTION = FETCH_PARTNER_ACTION + "_SUCCESS";

export const ADD_OUTBOX_ACTION = "ADD_OUTBOX_ACTION";
export const ADD_OUTBOX_FAIL_ACTION = ADD_OUTBOX_ACTION + "_ERROR";
export const ADD_OUTBOX_SUCCESS_ACTION = ADD_OUTBOX_ACTION + "_SUCCESS";

export const FETCH_SHIPPERINDIVIDUAL_ACTION = "FETCH_SHIPPERINDIVIDUAL_ACTION";
export const FETCH_SHIPPERINDIVIDUAL_FAIL_ACTION =
  FETCH_SHIPPERINDIVIDUAL_ACTION + "_ERROR";
export const FETCH_SHIPPERINDIVIDUAL_SUCCESS_ACTION =
  FETCH_SHIPPERINDIVIDUAL_ACTION + "_SUCCESS";

export function fetchrequesttype() {
  return {
    type: FETCH_REQUESTTYPE_ACTION,
  };
}
export function fetchpartner(value) {
  return {
    type: FETCH_PARTNER_ACTION,
    value: value,
  };
}

export function addoutbox(value) {
  return {
    type: ADD_OUTBOX_ACTION,
    value: value,
  };
}
export function fetchshipperindidal(value) {
  return {
    type: FETCH_SHIPPERINDIVIDUAL_ACTION,
    value: value,
  };
}